import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M6 5.3a9 9 0 0 1 0 13.4","key":"svg-1"}],["path",{"d":"M18 5.3a9 9 0 0 0 0 13.4","key":"svg-2"}]]

const IconBallTennis = createReactComponent('outline', 'ball-tennis', 'BallTennis', __iconNode);

export default IconBallTennis;